export const CONSULTANT_CLASS_ID = 'CONSULTANT' as const
export const CUSTOMER_CLASS_ID = 'CUSTOMER' as const

export const ContactClass = {
  CONSULTANT: CONSULTANT_CLASS_ID,
  CUSTOMER: CUSTOMER_CLASS_ID,
} as const

export type ContactClassType = typeof ContactClass[keyof typeof ContactClass]

// Returns undefined for class IDs without a label so callers can show the raw ID
// instead of a generic "Unknown" (other APP_BEE_CLASS IDs may exist per tenant)
export function getContactClassLabelKey(classId: string | null | undefined): string | undefined {
  const map: Record<string, string> = {
    [ContactClass.CONSULTANT]: 'contactClasses.Consultant',
    [ContactClass.CUSTOMER]: 'contactClasses.Customer',
  }
  return classId ? map[classId.toUpperCase()] : undefined
}
